import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/Layout.vue';
import Home from '@/views/Home.vue';
import UploadLocalization from '@/views/localization/index.vue';
import { Roles } from '@common/app.config';

import Thankyou from '@/views/Thankyou.vue';
import AuthRoutes from '@/routers/auth';
import ClinicRoutes from '@/routers/clinics';
import DoctorRoutes from '@/routers/doctors';
import DoctorShiftRoutes from '@/routers/doctor_shift';
import DoctorProfileRoutes from '@/routers/doctor_profile';
import PatientRoutes from '@/routers/patient';
import ShiftRoutes from '@/routers/shifts';
import MessageRoutes from '@/routers/message';
import ResvRoutes from '@/routers/resv';
// import MedicineRoutes from '@/routers/medicine';
import DiagnosisRoutes from '@/routers/diagnosis';
import ErrorRoutes from '@/routers/error';
import ClinicProfileRoutes from '@/routers/clinic_profile';
import MedicalMenuRoutes from '@/routers/medical_menu';
import PaymentRouters from '@/routers/payment';
import MedicalPrescriptionRouters from '@/routers/medical_prescription';
import NotificationRouters from '@/routers/notification';
import UploadRouters from '@/routers/upload';
import AppVersionRouter from '@/routers/app_version';
import SettingsRouter from '@/routers/setting';
import PharmacyRouter from '@/routers/pharmacy';
import MonthlyReportRouter from '@/routers/monthly_report';
import PharmacistRouter from '@/routers/pharmacist';
import RevenueRouter from '@/routers/revenue';
import PharmacistShiftRouter from '@/routers/pharmacist_shift';
import PharmacyMenuRouter from '@/routers/pharmacy_menu';
import PharmacistReservationRouter from '@/routers/pharmacist_reservation';
import PharmacistPatientRouter from '@/routers/pharmacist_patient';
import PharmacistPrescriptionRouter from '@/routers/pharmacist_prescription';
import PlanRoutes from '@/routers/plans';
import CallingRoutes from '@/routers/calling';
import OrderRouter from '@/routers/order.router';
import DeliveryRouter from '@/routers/delivery.router';
import AnswerRouter from '@/routers/answer';
// import CourseRouter from '@/routers/courses';
import DeliveriesRouter from '@/routers/deliveries';
import DoctorAdminsRouter from '@/routers/doctor-admins';
import ClinicPattern from '@/routers/clinic_pattern';
import UserRouters from '@/routers/member';
import QuestionRouters from '@/routers/question';
import LineMessageRouter from '@/routers/line_message.router';
import PatientV2 from '@/routers/v2/patient';
import SalesManagement from '@/routers/sales_management';
import Component from 'vue-class-component';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...AuthRoutes,
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
          meta: {
            auth: true,
            authorize: [],
          },
        },
        // {
        //   path: '/upload-localization',
        //   name: 'UploadLocalization',
        //   component: UploadLocalization,
        //   meta: {
        //     auth: true,
        //     authorize: [Roles.superAdmin],
        //   },
        // },
        ...ClinicRoutes,
        ...MessageRoutes,
        ...DoctorRoutes,
        ...DoctorShiftRoutes,
        ...DoctorProfileRoutes,
        ...PatientRoutes,
        // ...MedicineRoutes,
        ...DiagnosisRoutes,
        ...MedicalMenuRoutes,
        ...NotificationRouters,
        ...SettingsRouter,
        ...PlanRoutes,
        ...CallingRoutes,
        ...OrderRouter,
        ...DeliveryRouter,
        ...AnswerRouter,
        // ...CourseRouter,
        ...DoctorAdminsRouter,
        ...ClinicPattern,
        ...UserRouters,
        ...QuestionRouters,
        ...DeliveriesRouter,
        ...LineMessageRouter,
        // ...ResvRoutes,
        // ...UploadRouters,
        // ...AppVersionRouter,
        // ...MedicalPrescriptionRouters,
        // ...MonthlyReportRouter,
        // ...RevenueRouter,
        // ...ShiftRoutes,
        // ...ClinicProfileRoutes,
        // ...PaymentRouters,
        // ...PharmacyRouter,
        ...PharmacistRouter,
        // ...PharmacistShiftRouter,
        // ...PharmacyMenuRouter,
        ...PharmacistReservationRouter,
        // ...PharmacistPatientRouter,
        // ...PharmacistPrescriptionRouter,
        ...PatientV2,
        ...SalesManagement,
      ],
    },
    {
      path: '/thanks',
      name: 'resv.ended',
      component: Thankyou,
      meta: {
        auth: false,
      },
    },
    ...ErrorRoutes,
    {
      path: '*',
      redirect: { name: 'PageNotFound' },
    },
  ],
});
